import { useEffect, useState } from 'react';
import { search as searchAPI, stroot, GlobalSearchResult } from '@birdi/js-sdk';

const MAP_DATASETS_LIMIT = 100;

/**
 * Dataset layers of the currently selected map, for the "Selected Map
 * Datasets" tile (PRD). Independent of the search term and area filter:
 * selecting a map shows everything in it. Cleared when no map is selected;
 * a stale response for a previously selected map is ignored.
 */
export const useMapDatasets = (mapId: string | null) => {
  const [datasets, setDatasets] = useState<GlobalSearchResult[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!mapId) {
      setDatasets([]);
      setLoading(false);
      return undefined;
    }
    const controller = new AbortController();
    setLoading(true);
    searchAPI
      .getMapDatasets(stroot('gsrch'), mapId, {
        limit: MAP_DATASETS_LIMIT,
        signal: controller.signal,
      })
      .then((res) => {
        if (controller.signal.aborted) return;
        setDatasets(res.body?.results ?? []);
        setLoading(false);
      })
      .catch(() => {
        if (controller.signal.aborted) return;
        setLoading(false);
      });
    return () => controller.abort();
  }, [mapId]);

  return { datasets, loading };
};
